import React, { FC } from 'react';

import { Button, ButtonProps } from '@yandex-360/orb-components/dist/components/Button';
import { TooltipStateful } from '@yandex-360/orb-components/dist/components/Tooltip';

export interface FooterButtonProps extends Omit<ButtonProps, 'children' | 'iconLeft' | 'icon' | 'iconRight'> {
    content: string;
    tooltip?: string;
    mode?: 'full' | 'compact';
    icon?: React.ReactElement;
}

export const FooterButton: FC<FooterButtonProps> = ({ content, tooltip, mode = 'full', icon, ...props }) => {
    let button =
        mode === 'compact' ? (
            <Button {...props} icon={icon} />
        ) : (
            <Button iconLeft={icon} {...props}>
                {content}
            </Button>
        );
    if (tooltip || mode === 'compact') {
        button = (
            <TooltipStateful placement="top" content={tooltip ?? content} offset={14}>
                {button}
            </TooltipStateful>
        );
    }

    return button;
};
